import {createMuiTheme, useTheme} from '@material-ui/core/styles'
import {useMediaQuery} from '@material-ui/core'
import {CremaTheme} from '../../types/AppContextPropsType'
import {Breakpoint} from '@material-ui/core/styles/createBreakpoints'
import moment from 'moment'
import {useIntl} from 'react-intl'

type BreakpointOrNull = Breakpoint | null

export const isBreakPointDown = (key: 'xs' | 'sm' | 'md' | 'lg' | 'xl') => {
  const defaultTheme = createMuiTheme()
  return defaultTheme.breakpoints.width(key) > window.innerWidth
}

export const useDownBreakPointChecker = (
  key: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
) => {
  return useMediaQuery((theme: CremaTheme) => theme.breakpoints.down(key))
}

export const useBreakPointDown = (key: 'xs' | 'sm' | 'md' | 'lg' | 'xl') => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down(key))
}

export const useWidth = () => {
  const theme: CremaTheme = useTheme()
  const keys: Breakpoint[] = [...theme.breakpoints.keys].reverse()
  return (
    keys.reduce((output: BreakpointOrNull, key: Breakpoint) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key))
      return !output && matches ? key : output
    }, null) || 'xs'
  )
}

export const createRoutes = (routeConfigs: any[]) => {
  let allRoutes: any[] = []
  routeConfigs.forEach((config) => {
    allRoutes = [...allRoutes, ...setRoutes(config)]
  })
  return allRoutes
}

export const setRoutes = (config: any) => {
  let routes = [...config.routes]
  if (config.auth) {
    routes = routes.map((route) => {
      let auth = route.auth ? [...config.auth, ...route.auth] : [...config.auth]
      return {...route, auth}
    })
  }

  return [...routes]
}
export const getBreakPointsValue = (valueSet: any, breakpoint: string) => {
  if (typeof valueSet === 'number') return valueSet
  switch (breakpoint) {
    case 'xs':
      return valueSet.xs
    case 'sm':
      return valueSet.sm || valueSet.xs
    case 'md':
      return valueSet.md || valueSet.sm || valueSet.xs
    case 'lg':
      return valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs
    default:
      return (
        valueSet.xl || valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs
      )
  }
}
export const getFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes'
  let k = 1024,
    dm = 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const getCustomDateTime = (
  value = 0,
  unit = 'days',
  format = 'YYYY-MM-DD',
): string => {
  if (value === 0) {
    return moment().format(format) as string
  } else {
    // @ts-ignore
    return moment().add(value, unit).format(format) as string
  }
}

export const timeFromNow = (date: string) => {
  const timestamp = +moment(date).format('X')
  const newDate = moment.unix(timestamp)
  return moment(newDate).fromNow()
}

// 'intl' service singleton reference
let intl: any

export function IntlGlobalProvider({children}: any) {
  intl = useIntl()
  // Keep the 'intl' service reference
  return children
}

export const appIntl = () => {
  return intl
}
export const checkPermission = (
  routeAuth: any | null | undefined,
  userRole: any | null | undefined,
) => {
  if (routeAuth === null || routeAuth === undefined) {
    return true
  }

  if (userRole && Array.isArray(userRole)) {
    return routeAuth.some((r: any) => userRole.indexOf(r) >= 0)
  }

  if (routeAuth.length === 0) {
    return !userRole || userRole.length === 0
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeAuth)) {
    return routeAuth.some((r) => userRole.indexOf(r) >= 0)
  }
  return routeAuth.indexOf(userRole) >= 0
}

export interface FormAttr {
  name: string
  required: boolean
  onError: any
  value: any
  type?: string
}

export const validateForm = (attrs: Array<FormAttr>): boolean => {
  for (let i: number = 0; i < attrs.length; i++) {
    if (attrs[i].required && !attrs[i].value && attrs[i].type !== 'terms') {
      attrs[i].onError(`${attrs[i].name} cannot be empty.`)
      return false
    }

    if (attrs[i].required && !attrs[i].value && attrs[i].type === 'terms') {
      attrs[i].onError(`Please agree to the terms and conditions.`)
      return false
    }

    if (attrs[i].type === 'email' && attrs[i].value) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!re.test(attrs[i].value)) {
        attrs[i].onError(`${attrs[i].name} format is not valid.`)
        return false
      }
    }
  }
  return true
}

export const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
)
